/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportCatalogItem {
    getFixupPrototypeFunction() { return ReportCatalogItem.fixupPrototype; }

    static newInstance(model: Partial<ReportCatalogItem>): ReportCatalogItem {
        let obj = Object.assign(new ReportCatalogItem(), model);
        ReportCatalogItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportCatalogItem>): ReportCatalogItem {
        if (!model) return null;
        return ReportCatalogItem.newInstance(<ReportCatalogItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportCatalogItem) {
        if (!obj) return;

        models.ReportCatalogItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportCatalogItem): boolean {
        Object.setPrototypeOf(obj, ReportCatalogItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique id of the report
     */
    id: string;

    /**
     * Raw report name, with underscores in place of spaces
     */
    name: string;

    /**
     * Engine that renders the report
     */
    engine: models.ReportEngine;

    /**
     * Report type, e.g. paginated for Power BI paginated reports
     */
    report_type: string;

    /**
     * Clouds the report covers: one cloud for a cloud-specific report, several for a multi-cloud report, empty for a general report
     */
    services: Array<models.CloudServiceName>;

    /**
     * Scope of the report: global, custom or my_reports
     */
    scope: models.ReportCatalogScope;

    /**
     * Raw report group, e.g. Cost
     */
    group: string;

    /**
     * Sub-category of the report, e.g. cost_reports
     */
    sub_category: string;

    /**
     * Product category of the report
     */
    category: models.ReportProductCategory;

    /**
     * Whether the current user has pinned the report
     */
    pinned: boolean;

    /**
     * Additional information about the report
     */
    info: string;

    /**
     * Tenant the report is provisioned for; only set for the my_reports scope
     */
    tenant_id: string;

}
